import { render, staticRenderFns } from "./UserManualButton.vue?vue&type=template&id=74458a70&"
import script from "./UserManualButton.vue?vue&type=script&lang=js&"
export * from "./UserManualButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports